const usersPaths = {
  basePath: "users",
};

export default usersPaths;
